@if(limitOrderCombinedFF$ | async; as ff) {
<div>
	@if(watchlistVM$ | async; as watchlist) { @if(ff.buyEnabled && ff.sellEnabled) {
	<div class="following-widget-header">
		<span class="following-title">{{ "following_widget_title" | translate }}</span>
		<bp-toggle-group
			[options]="allPills"
			[selected]="selectedPill$ | async"
			(onValueChange)="onFilterChange($event)">
		</bp-toggle-group>
	</div>
	} @switch ((selectedPill$ | async).value) { @case (FOLLOWING_PILLS.WATCHLIST) {
	<watchlist-widget [vm]="watchlist" [isLimOrdEnabled]="ff.buyEnabled && ff.sellEnabled"></watchlist-widget>
	} @case (FOLLOWING_PILLS.BUY_ORDERS) {
	<limit-orders-widget-ui
		[vm]="orders$(orderType.Buy) | async"
		[counts]="counts$().data"
		[selectedPill]="FOLLOWING_PILLS.BUY_ORDERS"
		(onRefetchOrders)="onInvalidateOrdersCache()"
		(onGoToLimitOrders)="goToLimitOrders(FOLLOWING_PILLS.BUY_ORDERS)"></limit-orders-widget-ui>

	} @case (FOLLOWING_PILLS.SELL_ORDERS) {
	<limit-orders-widget-ui
		[vm]="orders$(orderType.Sell) | async"
		[counts]="counts$().data"
		[selectedPill]="FOLLOWING_PILLS.SELL_ORDERS"
		(onRefetchOrders)="onInvalidateOrdersCache()"
		(onGoToLimitOrders)="goToLimitOrders(FOLLOWING_PILLS.SELL_ORDERS)"></limit-orders-widget-ui>

	} @case (FOLLOWING_PILLS.TOTAL_ORDERS) {
	<limit-orders-widget-ui
		[vm]="orders$() | async"
		[counts]="counts$().data"
		[selectedPill]="FOLLOWING_PILLS.TOTAL_ORDERS"
		(onRefetchOrders)="onInvalidateOrdersCache()"
		(onGoToLimitOrders)="goToLimitOrders(FOLLOWING_PILLS.TOTAL_ORDERS)"></limit-orders-widget-ui>

	} } }
</div>
}
